import { VoucherRevokeType } from "../../enums";

export const POSSIBLE_CHOICES = [
  VoucherRevokeType.Voucher,
  VoucherRevokeType.Standard,
];

export const POSSIBLE_CHOICES_LABELS = {
  [VoucherRevokeType.Standard]: "lp_voucher_revoke_choice_standard",
  [VoucherRevokeType.Voucher]: "lp_voucher_revoke_choice_voucher",
};
